import { atom, useAtom } from "jotai";

export const perpIsPostOnlyAtom = atom<boolean>(false);

export const usePerpIsPostOnly = () => {
  const [perpIsPostOnly, setPerpIsPostOnly] = useAtom(perpIsPostOnlyAtom);

  return {
    perpIsPostOnly,
    setPerpIsPostOnly,
  };
};
